import GeocoderImg from "../../../assets/geocoder.png"
import WrongVRIImg from "../../../assets/wrongvri.png"
import IZHSImg from "../../../assets/izhsnotcadaster.png"
import FIASGeocodedImg from "../../../assets/fiasgeocoded.png"
import OKSGeocodedImg from "../../../assets/oksgeocoded.png"
import OSMPlusImg from "../../../assets/osmplus.png"


export const ourServicies = [
    {
        'id': 'geocoder',
        'title': 'Геокодер',
        'description': 'Превратить табличные данные в пространственные с обогащением',
        'href': '/geocoder',
        'img': GeocoderImg
    },
    {
        'id': 'wrongvri',
        'title': 'Нарушения ВРИ',
        'description': 'Найти, где есть основание повысить земельный налог: коммерческая деятельность происходит на землях ИЖС',
        'href': '/product/wrongvri/',
        'img': WrongVRIImg
    },
    {
        'id': 'izhsnotcadaster',
        'title': 'ИЖС не на кадастре',
        'description': 'Найти не стоящие на кадастре ИЖС и заставить платить земельный налог',
        'href': '/product/izhsnotcadaster/',
        'img': IZHSImg
    },
    {
        'id': 'fiasgeocoded',
        'title': 'Геокодированный ФИАС',
        'description': 'Найти место каждого объекта адресации из ФИАС от региона до дома, найти дополнительные связи с ЕГРН',
        'href': '/product/fiasgeocoded/',
        'img': FIASGeocodedImg
    },
    {
        'id': 'osmplus',
        'title': 'OpenStreetMap+',
        'description': 'Дополняем OpenStreetMap до правдоподобного: укажем, какие объекты OSM подтверждаются по другим источникам, какие пропущены, какие лишние',
        'href': '/product/osmplus/',
        'img': OSMPlusImg
    },
    {
        'id': 'oksgeocoded',
        'title': 'Геокодированные ОКС',
        'description': 'Найдем геометрию для ОКС без координат: в ЕГРН только 20-25% имеют координаты, найдем еще для 30-50%',
        'href': '/product/oksgeocoded/',
        'img': OKSGeocodedImg
    }
] 